(function() {
	'use strict';

	angular.module('quantixApp').factory('ErrorHandlerService',
			ErrorHandlerService);

	ErrorHandlerService.$inject = ['$http','$q', '$window', '$location', '$state', 'AlertService'];

	function ErrorHandlerService($http, $q, $window, $location, $state, AlertService) {	
		
		var _forbiddenError = function(moduleName) {
			//alert(moduleName);
			$state.go('forbidden', {'modulename' : moduleName});
		}
		var _forbiddenErrorForDetail = function(moduleName,companyCode,companyName) {
			//alert(moduleName);
			$state.go('forbiddenDetails', {'modulename' : moduleName,'companyCode':companyCode,'companyName':companyName});
		}
		var _forbiddenErrorForDetailForPortFolio = function(moduleName,portfolioId,portfolioName,portfolioType,portfolioDateTime) {
			//alert(moduleName);
			$state.go('forbiddenDetailsForPortfolio', {'modulename' : moduleName,'portfolioId' : portfolioId,'portfolioName':portfolioName,'portfolioType':portfolioType,'portfolioDateTime':portfolioDateTime});
		}
		
		var _handleError = function(errorResponse, status, headers, config) {
			var loc = $window.location;//Current windows location

			var currentLocation = loc.hash.split("/");
			var currentLocationModuleName = currentLocation.pop();
			
			switch(status) {
				case 204:
					//No Content found
					$state.go(currentLocationModuleName);
					AlertService.error(errorResponse.description);
					break;
				case 403:
					//Forbidden
					$state.go('home');
					AlertService.error("Fatal error has occurred. Please contact administrator");
					break;
				case 404:
					//Page not found
					$state.go('notFound');
					break;
				case 503:
					//Service unavailable
					$state.go('serviceUnavailable');
					break;
				case 500:
					//Internal Server Error
					$state.go(currentLocationModuleName);
					break;
				default:
					//Others
					$state.go(currentLocationModuleName);
					break;
			}
			
		}
		
		return {
			handleError : _handleError,
			forbiddenError : _forbiddenError,
			forbiddenErrorForDetail:_forbiddenErrorForDetail,
			forbiddenErrorForDetailForPortFolio:_forbiddenErrorForDetailForPortFolio
		};
	}
})();
